import React from 'react'

const EmptyState = () => (
  <div className='rp-empty-state'>
    <div className='rp-empty-state__title'>
      入荷番号を選択して配分結果を表示します
    </div>
  </div>
)

export default EmptyState
